import { Link } from "react-router-dom";
import styled from "styled-components";
export const LinkStyle = styled(Link)`
  color:var(--color-blue);
  font-size:12px;
`;
